<template>
<!-- 菜单 -->
<div class="x-sidebar-menu" :style="style" v-if="menuData.length">

    <!-- 常规菜单 -->
    <div class="x-default-sidebar menu-scrollbar" v-show="!showMini">
        <el-menu :default-active="activeMenu" :unique-opened="uniqueOpened" :background-color="backgroundColor" :text-color="textColor" :active-text-color="activeTextColor" @select='selectMenu'>
            <template v-for="(item, index) in menuData">
                <el-submenu v-if="item.child.length" :index="item[menuKey] ? item[menuKey] : index+''" :key="index">
                    <template slot="title">
                        <i :class="['left-icon', 'iconfont', item.icon]"></i>
                        <span class="menu-title" slot="title">{{item.menuName}}</span>
                    </template>
                    <el-menu-item v-for="(child, index) in item.child" :index="child[menuKey] ? child[menuKey] : index+''" :key="index">{{child.menuName}}</el-menu-item>
                </el-submenu>
                <el-menu-item v-else :index="item[menuKey] ? item[menuKey] : index+''">
                    <i :class="['left-icon', 'iconfont', item.icon]"></i>
                    <span class="menu-title" slot="title">{{item.menuName}}</span>
                </el-menu-item>
            </template>
        </el-menu>
    </div>

    <!-- 迷你菜单 -->
    <div class="x-min-sidebar menu-scrollbar" ref="sidebar" v-show="showMini" :style="style">
        <template v-for="(item, index) in menuData">
            <div :class="['x-min-item', 'x-flex-center', {'x-active-min-item': item.menuName === miniActive}]" @mouseenter="showColumn(item.menuName, $event)" @mouseleave="hideColumn">
                <div class="x-min-icon" @click.stop="selectMinMenu(item.menuUrl)">
                    <i :class="['iconfont', item.icon]"></i>
                </div>
                <transition enter-class="min-list-hide" enter-to-class="min-list-show">
                    <ul class="x-min-list" v-if="item.child.length && item.menuName == minName" :style="listStyle">
                        <li :class="{'x-active-min-list': child.menuUrl === activeMenu}" v-for="(child, index) in item.child" @click.stop="selectMinMenu(child.menuUrl)">{{child.menuName || item.menuName}}</li>
                    </ul>
                    <ul class="x-min-list" v-if="!item.child.length && item.menuName == minName" :style="listStyle">
                        <li :class="{'x-active-min-list': item.menuUrl === activeMenu}" @click.stop="selectMinMenu(item.menuUrl)">{{item.menuName}}</li>
                    </ul>
                </transition>
            </div>
        </template>
    </div>
</div>
</template>

<script>
export default {
  name: 'MyMenu',
  props: {
    menuData: { // 菜单数据
      type: Array,
      default: () => {
        return [];
      }
    },
    showMini: { // 控制切换大小菜单栏
      type: Boolean,
      default: false,
    },
    activeMenu: { // 当前激活菜单
      type: String,
      default: ''
    },

    menuKey: { // 唯一的key值
      type: String,
      default: 'menuUrl'
    },
    // miniActive: { // mini当前激活菜单(高亮最外那一层的菜单)
    //     type: String,
    //     default: ''
    // },
    width: { // 菜单宽度
      type: String,
      default: '180'
    },
    minWidth: { // min菜单宽度
      type: String,
      default: '60'
    },
    topHeight: {
      type: Number,
      default: 60
    },
    uniqueOpened: { // 是否只展开单个
      type: Boolean,
      default: true
    },
    backgroundColor: { // 背景色
      type: String,
      default: '#182C69'
    },
    textColor: { // 文字颜色
      type: String,
      default: '#A2AAC3'
    },
    activeTextColor: { // 激活文字颜色
      type: String,
      // default: '#0087ff'
      default: '#fff'
    },
  },

  data() {
    return {
      minName: '', // hover的min菜单名称
      minTop: 0, // min子菜单top距离
      // minbottom: false, // 底部距离不够需要改变定位位置
    };
  },

  computed: {
    style() {
      let style = {};
      if (this.showMini) {
        style.width = this.minWidth + 'px';
      } else {
        style.width = this.width + 'px';
      }
      style.backgroundColor = this.backgroundColor;
      style.color = this.textColor;
      return style;
    },

    listStyle() {
      let style = {};
      style.top = this.minTop + 'px';
      // if (this.minbottom) {
      //     style.transform = 'translateY(-50%)';
      // }
      return style;
    },

    miniActive() { // min菜单当前激活
      return this.retuenMenu(this.activeMenu);
    }
  },

  methods: {

    /**
         * 点击菜单栏
         * @param {String} url 路由地址
         */
    selectMenu(url) {
      this.$emit('selectMenu', url);
    },

    /**
         * 点击min菜单栏
         * @param {String} url 路由地址
         */
    selectMinMenu(url) {
      if (url) {
        this.minName = '';
        this.$emit('selectMenu', url);
      }
    },

    /**
         * 显示min子菜单
         * @param {String} name 菜单名字
         * @param {Object} e 事件对象
         */
    showColumn(name, e) {
      this.minTop = e.target.offsetTop - this.$refs.sidebar.scrollTop + this.topHeight; // 计算top距离
      // let wh = document.body.clientHeight;
      // if (wh - this.minTop <= 56) {
      //     this.minbottom = true;
      // } else {
      //     this.minbottom = false;
      // }
      this.minName = name;
    },

    /**
         * 隐藏min子菜单
         */
    hideColumn() {
      this.minName = '';
    },

    /**
         * 根据当前路由判断主菜单
         * @param {String} val 当前路由
         */
    retuenMenu(val) {
      let menuName = '';
      for (let i = 0; i < this.menuData.length; i++) {
        if (menuName) {
          break;
        }
        let item = this.menuData[i];
        if (item.child.length) {
          for (let j = 0; j < item.child.length; j++) {
            let child = item.child[j];
            if (child.menuUrl == val) {
              menuName = item.menuName;
              break;
            }
          }
        } else {
          if (item.menuUrl === val) {
            menuName = item.menuName;
          }
        }
      }
      return menuName;
    }
  }
};
</script>

<style lang="scss">
$text-color: #7480A5; // 文字颜色
$text-size: 15px; // 文字大小
$icon-right: 10px; // 左侧icon距离文字的间距
$opend-text-color: #fff; // 当前展开的文字的颜色
$menu-padding: 0 24px;

$child-menu-BGcolor: #263f8f; // 二级菜单背景颜色
$child-menu-padding: 0 24px 0 54px; // 二级菜单padding
$child-hover-color: #fff; // 二级菜单hover文字颜色

$min--itme-height: 56px; // min菜单高度
$min--menu-width: 60px; // min菜单宽度
$min--icon-size: 20px; // min菜单icon大小
$min-hover-color: #132354; // min菜单hover
// $min-active-color: #0087ff; // 当前激活颜色
$min-active-color: #fff; // 当前激活颜色

.x-sidebar-menu {
    height: 100%;
    display: flex;
    flex-direction: column;
    user-select: none;

    // 常规菜单
    .x-default-sidebar {
        width: 100%;
        flex: 1;

        // 左边图标
        .left-icon {
            width: 20px;
            margin-right: $icon-right;
            font-size: $text-size;
            line-height: $text-size;
            color: $text-color;
            text-align: center;
        }

        // 一级菜单文字
        .menu-title {
            flex: 1;
            padding-right: 20px;
            font-size: $text-size;
            text-align: left;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }

        // 一级菜单(边距, 垂直居中)
        .el-menu-item,
        .el-submenu__title {
            display: flex;
            align-items: center;
            padding: $menu-padding !important;
        }

        .el-submenu__icon-arrow {
            margin-top: -5px;
            color: #A2AAC3;
        }

        // 二级菜单(边距, 背景色, 超出影藏)
        .el-menu--inline .el-menu-item {
            display: inherit;
            padding: $child-menu-padding !important;
            font-size: $text-size;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            background-color: $child-menu-BGcolor !important;

            &:hover {
                color: $child-hover-color !important;
                background-color: #13235480;
            }
        }

        .el-menu-item.is-active {
            background-color: $min-hover-color;

            .left-icon {
                color: $min-active-color;
            }
        }

        .el-submenu.is-active {

            .el-submenu__title {
                background-color: $min-hover-color !important;
            }
        }

        // 展开的样式(当前展开文字颜色)
        // .el-submenu.is-opened {

        // 左侧图标和文字
        // .left-icon,
        // .el-submenu__title {
        //     color: $opend-text-color !important;
        // }
        // }

        // 去掉右边自带的边框
        .el-menu {
            border: 0 none;
        }
    }
}

.menu-scrollbar {
    overflow-y: auto;
    overflow-x: hidden;

    &::-webkit-scrollbar {
        width: 3px;
    }

    // 定义滚动条轨道
    &::-webkit-scrollbar-track {
        border-radius: 10px;
        background-color: #132354;
    }

    // 定义滚动条滑块
    &::-webkit-scrollbar-thumb {
        border-radius: 10px;
        background-color: #182c69;
    }
}

// min菜单
.x-min-sidebar {
    flex: 1;
    position: relative;
    width: 100%;

    // min菜单按钮
    .x-min-item {
        width: 100%;
        height: $min--itme-height;
        cursor: pointer;

        &:hover {
            background-color: $min-hover-color;
        }

        // 图标大小
        .x-min-icon {
            width: 100%;
            height: 100%;
            text-align: center;
            line-height: $min--itme-height;

            .iconfont {
                font-size: $min--icon-size;
            }
        }

        .x-min-list {
            position: fixed;
            z-index: 10000;
            left: $min--menu-width;
            cursor: pointer;
            transform-origin: left;

            >li {
                width: 90px;
                height: 56px;
                padding: 0 20px;
                line-height: 56px;
                font-size: $text-size;
                background-color: $child-menu-BGcolor;
            }

            >li:hover {
                color: $child-hover-color;
            }

            .x-active-min-list:hover {
                color: $min-active-color;
            }

            // 二级菜单激活色
            .x-active-min-list {
                color: $min-active-color;
            }
        }
    }

    // 一级激活菜单图标色
    .x-active-min-item {

        .iconfont {
            color: $min-active-color;
        }
    }

    .min-list-hide {
        transform: scaleX(0);
        transition: all 0.3s ease;
        // transform: perspective(500px) rotate3d(0,1,0,90deg);

    }

    .min-list-show {
        transform: scaleX(1);
        transition: all 0.3s ease;
    }

    .enter-to-min {
        transform: scaleX(1);
        // transform: perspective(800px) rotate3d(0,1,0,0deg);
        transform-origin: left;
    }
}
</style>
